import { createUseStyles } from 'react-jss';

import { mediaQuery, Transition } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, breakpoints }: ITheme) => ({
    item: {
      width: '100%',
      borderBottom: `1px solid var(--x-bg-3)`,
    },
    toggle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.large,

      width: '100%',
      padding: [spacing.xxxLarge, 0, spacing.xxLarge],

      textAlign: 'left',

      border: 'none',
      background: 'none',

      cursor: 'pointer',

      '&[data-state="open"]': {
        '& > $chevron': {
          transform: 'rotate(-180deg)',
        },
      },

      [mediaQuery(breakpoints.tablet)]: {
        padding: [spacing.large, 0, spacing.large],
      },
    },
    chevron: {
      fill: 'var(--x-accent-2-1)',
      transition: `transform ${Transition.Default} ease-in-out`,
    },
    content: {
      paddingBottom: spacing.large,
    },
  }),
  {
    name: 'accordion',
  },
);

export default useStyles;
